/**
 * @module
 * @name InputFile
 * @description Wrapper for basic native file input element.
 * @extends Input
 */
export default {
  name: 'InputFile',
  /**
   * @function
   * @property {file} file File object.
   */
  data: function () {
    return {
      file: null
    }
  },

  /**
   * @property {String} name Input element name
   */
  props: {
    name: {
      type: String,
      required: true
    },
    mimetypeAccepted: {
      type: String,
      required: false
    }
  },

  /**
   * @property {String} comFileName Returns filename or returns no file message.
   */
  computed: {
    comFileName: function () {
      if (this.file && this.file.name.length > 0) {
        return this.file.name
      } else {
        return this.$t('common.noFile')
      }
    }
  },

  methods: {
  /**
   * @function
   * @name handleSelectFileClick
   * @description Trigger input file click. It shows system file selector.
   */
    handleSelectFileClick: function () {
      this.$refs[this.name].click()
    },
    /**
     * @function
     * @name handleInputChange
     * @param {Object} event Event object from where file object is taken.
     * @description Set component instance file.
     */
    handleInputChange: function (event) {
      this.file = event.target.files[0]
      this.$emit('change', this.file)
    },
    /**
     * @function
     * @name handleDeleteFile
     * @description data.file is set to null and native HTML file input value
     *              is deleted too.
     */
    handleDeleteFile: function () {
      this.file = null
      this.$refs[this.name].value = null
      this.$emit('delete')
    }
  }
}
